import { FormInputExtendedProps } from "@dirootie-web/components-types";
import { Col, Form, Row } from "taltech-styleguide";
import {
  InputCheckbox,
  InputNumber,
  InputNumberFloat,
} from "@components-common/forms";
import { WindowPositionSelector } from "./WindowPositionSelector";
import { useField } from "formik";

/**
 * WindowMeasureInput Component
 *
 * Renders a form group for window measurement input, including position selector, length input, and optional maximum checkbox.
 *
 * @param {Object} props - The properties for the window measure input component.
 * @param {string} props.id - The unique identifier for the input fields.
 * @param {string} props.label - The label for the form group.
 * @param {boolean} [props.showMaximum] - Flag to show the maximum checkbox.
 * @returns {JSX.Element} - The rendered window measure input component.
 */
export const WindowMeasureInput = ({
  id,
  label,
  ...props
}: Omit<FormInputExtendedProps, "formState"> & { showMaximum?: boolean }) => {
  const [fieldPosition] = useField(`${id}.position`);
  const maximumContent = props.showMaximum ? (
    <InputCheckbox
      label="Maximum"
      parentClass="ebd-min-input-width mx-1 my-0"
      id={`${id}.maximum`}
      name={`${id}.maximum`}
    />
  ) : (
    <></>
  );

  return (
    <Form.Group>
      <Form.Label>{label} <text style={{ color: "red" }}> *</text></Form.Label>
      <Row className="align-items-end">
        <Col sm={4}>
          <WindowPositionSelector
            parentClass="ebd-min-input-width mx-1 my-0"
            id={`${id}.position`}
            label=""
            {...props}
          />
        </Col>

        <Col sm={7}>
          <InputNumberFloat
            parentClass="ebd-min-input-width mx-1 my-0"
            id={`${id}.length`}
            name={`${id}.length`}
            label=""
            suffix={fieldPosition.value === "ABSOLUTE" ? " m" : "%"}
            fixedDecimalScale={false}
            showHelp={false}
            maxValue={fieldPosition.value === "RELATIVE" ? 100 : 2000}
            {...props}
          />
        </Col>
        <Col sm={1}>{maximumContent}</Col>
      </Row>
      {/* <FeedbackMessage fieldId={id}></FeedbackMessage> */}
    </Form.Group>
  );
};
